/**
 * Tokens de composición del shell (Fase B — Rediseño Maestro). No son
 * colores/tipografía (eso ya vive en `palette.ts`/`typography.ts` y no se
 * toca) sino las medidas estructurales que Sidebar/Topbar/AppLayout deben
 * compartir para no divergir con el tiempo.
 */
export const TOPBAR_HEIGHT = 68

/** Padding responsive del contenido principal — más generoso que antes
 * (más espacio negativo) para que las páginas dejen de sentirse
 * apiñadas contra el borde del viewport. */
export const CONTENT_PADDING = { xs: 2, sm: 3, md: 4, lg: 5 } as const
